
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/miro-to-mural",
      function () {
        return require("private-next-pages/converter/miro-to-mural.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/miro-to-mural"])
      });
    }
  